import { ASSET_DIR } from '@/constants/agriOutput'

import Picture from '../picture'
interface MobileSolutionListProps {
  accorditonList: {
    heading: string
    description: string
    icon: string
    image: string
    imageAlt: string
  }[]
}

const MobileSourcingRegionList = ({
  accorditonList,
}: MobileSolutionListProps) => (
  <section className="md:hidden">
    <section className="relative flex justify-center items-center pt-6 md:w-1/2">
      <Picture
        image={`${ASSET_DIR}/spices-map`}
        imageAlt={'Source region map of spices'}
        imageStyle={`sticky top-0 left-0 transition-opacity duration-500 opacity-100 visible max-h-[83vh]`}
        key={'Source region map of spices'}
      />
    </section>
    {accorditonList.map(({ heading, icon, description }, index) => (
      <section className="flex mt-4 mb-2.5" key={index}>
        {icon ? (
          <Picture
            image={icon}
            imageAlt={heading}
            aria-hidden="true"
            role="presentation"
            imageStyle="mr-4 mt-1 w-14 h-14"
          />
        ) : null}
        <article className="flex-1">
          <p className="font-natosans-medium font-medium text-[#101010] text-lg leading-[1.36]">
            {heading}
          </p>
          <p className="font-natosans-light text-footer-grey text-base">
            {description}
          </p>
        </article>
      </section>
    ))}
  </section>
)

export default MobileSourcingRegionList
